import axios from 'axios';

const ADMIN_API_URL = process.env.REACT_APP_API_URL + 'admin/accounts/';

const axiosConfig = {
  withCredentials: true
};

const getAll = (accountId, params) => {
  return axios.get(ADMIN_API_URL + accountId + '/payouts', {
    params,
    ...axiosConfig
  });
};

const getBalanceTransactionReceipt = (accountId, btUuid) => {
  return axios.get(
    ADMIN_API_URL + accountId + '/payouts/balance-transactions/' + btUuid + '/receipt',
    axiosConfig
  );
};

const getScheduleState = (accountId) => {
  return axios.get(ADMIN_API_URL + accountId + '/payouts/schedule', axiosConfig);
};

const setScheduleLock = (accountId, locked) => {
  return axios.put(ADMIN_API_URL + accountId + '/payouts/schedule-lock', { locked }, axiosConfig);
};

const PayoutService = {
  getAll,
  getBalanceTransactionReceipt,
  getScheduleState,
  setScheduleLock
};

export default PayoutService;
